import { Box, Card, CardBody, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { getPixelCount } from "../../../utils";

const ReportCard = ({
  title = "",
  amount = "0.00",
  forecast = "0.00",
  forecast_percentage = "0.00",
  ytd = "0.00",
  ytd_percentage = "0.00",
  forecast_color = "black",
  ytd_color = "black",
}) => {
  return (
    <Stack width="100%" align="center" p="10px 0px" fontFamily={"lato"}>
      <Card
        boxShadow="none"
        width="100%"
        height={"187px"}
        borderRadius="10px"
        position="relative"
        outline={"1px solid #CBD5E0"}
      >
        <CardBody boxShadow="none" padding={"16px 24px"}>
          <Box align={"left"}>
            <Text fontSize={"14px"} margin={0} color={"#202224"}>
              {title}
            </Text>
            <Text
              fontSize={getPixelCount("26px", amount, 8, 2)}
              fontWeight={800}
              margin={0}
            >
              {amount}
            </Text>
          </Box>

          <SimpleGrid templateColumns="1fr 1fr" p="5px 0px" alignItems="end">
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="flex-end"
              p={0}
              borderRightWidth="2px"
              borderColor="gray.200"
              width="85%"
              height="80px"
            >
              <Text fontSize="14px" margin={0} color="#202224">
                Target
              </Text>
              <Text
                fontSize={getPixelCount("18px", forecast, 8, 2)}
                margin={0}
                fontWeight={600}
              >
                {forecast}
              </Text>
              <Text fontSize="14px" margin={0} color={forecast_color}>
                {forecast_percentage}
              </Text>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              justifyContent="flex-end"
              height="80px"
            >
              <Text fontSize="14px" margin={0} color="#202224">
                YTD Average
              </Text>
              <Text
                fontSize={getPixelCount("18px", forecast, 8, 2)}
                margin={0}
                fontWeight={600}
              >
                {ytd}
              </Text>
              <Text fontSize="14px" margin={0} color={ytd_color}>
                {ytd_percentage}
              </Text>
            </Box>
          </SimpleGrid>
        </CardBody>
      </Card>
    </Stack>
  );
};

export default ReportCard;
